import React, { useState } from "react";
import axios, { authIsValid } from "../axios";
import { useNavigate } from "react-router-dom";

function SendList({ setShowSendList, access_token, listId }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sendListResponse, setSendListResponse] = useState("");

  const handleSendList = async (e) => {
    e.preventDefault();
    setSendListResponse("Sending...");
    try {
      const response = await axios.post(
        "/users/sendList",
        { listId, email },
        { headers: { "x-access-token": access_token } }
      );
      if (authIsValid(response.data.message) === false) {
        navigate("/mixer");
      } else {
        setSendListResponse(response.data.message);
      }
      setTimeout(() => {
        setShowSendList(false);
      }, 1500);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div id="sendListContainer" className="col-md-3 col-sm-6 col-xs-12">
      <form className="row justify-content-center">
        <h5 className="color-ryoForest text-center">Send List</h5>
        {sendListResponse !== "" && (
          <p className="color-ryoForest text-center">{sendListResponse}</p>
        )}
        <div className="form-group col-12">
          <label htmlFor="email" className="col-form-label col-2 text-center">
            Email
          </label>
          <input
            id="email"
            className="form-control"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="col-12 text-center">
          <button
            className="btn btn-md btn-ryoSilver"
            type="button"
            onClick={() => setShowSendList(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-md btn-ryoForest"
            type="submit"
            style={{ marginLeft: "20px" }}
            onClick={handleSendList}
          >
            Send
          </button>
        </div>
      </form>
    </div>
  );
}

export default SendList;
